<div class="modal-title d-flex justify-content-between px-3 mt-3" [attr.data-qa]="testIdPrefix + '-container-'">
  <h3 class="title-message">{{ title() }}</h3>
  <rx-button
    [compact]="true"
    buttonClass="subtle-circle"
    (click)="cancel.emit()"
    [attr.data-qa]="testIdPrefix + '-button-close'"
  >
    <rx-icon name="close" size="md" />
  </rx-button>
</div>
<p class="modal-body py-0">
  {{ message() }}
</p>
<div class="modal-footer d-flex justify-content-end pb-3">
  <rx-button
    buttonClass="subtle"
    [compact]="true"
    class="mr-2"
    (click)="cancel.emit()"
    [attr.data-qa]="testIdPrefix + '-button-cancel'"
    >{{ cancelText() }}</rx-button
  >
  <rx-button
    buttonClass="primary"
    [compact]="true"
    (click)="confirm.emit()"
    [attr.data-qa]="testIdPrefix + '-button-confirm'"
    >{{ confirmText() }}</rx-button
  >
</div>
